// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Typography,
//   Box,
//   Button,
//   Card,
//   CardContent,
//   CircularProgress,
//   Tooltip,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   IconButton,
//   Stack,
// } from "@mui/material";
// import {
//   PictureAsPdf,
//   Feedback,
//   Notifications,
//   AttachMoney,
//   PendingActions,
//   Done,
// } from "@mui/icons-material";

// const MyInvestment = () => {
//   const [investments, setInvestments] = useState([]);

//   // Dummy data
//   useEffect(() => {
//     const dummyData = [
//       {
//         id: 1,
//         title: "AI-Driven Healthcare App",
//         status: "In Progress",
//         amountInvested: "₹50,000",
//         pendingInstallments: "₹20,000",
//         invoice: "Invoice_1.pdf",
//         feedbackGiven: false,
//         notices: "Project update: Phase 1 completed.",
//       },
//       {
//         id: 2,
//         title: "Green Energy Solar Panel Project",
//         status: "Completed",
//         amountInvested: "₹75,000",
//         pendingInstallments: "₹0",
//         invoice: "Invoice_2.pdf",
//         feedbackGiven: true,
//         notices: "Final report shared.",
//       },
//       {
//         id: 3,
//         title: "Blockchain-Based Supply Chain",
//         status: "Pending",
//         amountInvested: "₹1,00,000",
//         pendingInstallments: "₹50,000",
//         invoice: "Invoice_3.pdf",
//         feedbackGiven: false,
//         notices: "Awaiting investor approval for next stage.",
//       },
//     ];
//     setInvestments(dummyData);
//   }, []);

//   const handleFeedback = (project) => {
//     alert(`Provide feedback for: ${project.title}`);
//   };

//   const handleInvoiceDownload = (invoice) => {
//     alert(`Download invoice: ${invoice}`);
//   };

//   const handleNoticeView = (project) => {
//     alert(`View notice for: ${project.title}\n\n${project.notices}`);
//   };

//   return (
//     <Container maxWidth="lg" sx={{ mt: 11, mb: 4 }}>
//       <Typography variant="h4" gutterBottom align="center" sx={{ mb: 4 }}>
//         My Investments
//       </Typography>
//       <Card
//         sx={{
//           boxShadow: 3,
//           borderRadius: 3,
//           background: "linear-gradient(to bottom, #f0f0f5, #ffffff)",
//         }}
//       >
//         <CardContent>
//           <TableContainer>
//             <Table sx={{ minWidth: 650 }}>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>Project Title</TableCell>
//                   <TableCell>Status</TableCell>
//                   <TableCell>Amount Invested</TableCell>
//                   <TableCell>Pending Installments</TableCell>
//                   <TableCell align="center">Invoice</TableCell>
//                   <TableCell align="center">Feedback</TableCell>
//                   <TableCell align="center">Notices</TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 {investments.map((project) => (
//                   <TableRow key={project.id}>
//                     <TableCell>{project.title}</TableCell>
//                     <TableCell>
//                       {project.status === "Completed" ? (
//                         <Done sx={{ color: "green" }} />
//                       ) : project.status === "In Progress" ? (
//                         <PendingActions sx={{ color: "orange" }} />
//                       ) : (
//                         <AttachMoney sx={{ color: "red" }} />
//                       )}
//                       {project.status}
//                     </TableCell>
//                     <TableCell>{project.amountInvested}</TableCell>
//                     <TableCell>
//                       {project.pendingInstallments === "₹0" ? (
//                         <Done sx={{ color: "green" }} />
//                       ) : (
//                         project.pendingInstallments
//                       )}
//                     </TableCell>
//                     <TableCell align="center">
//                       <Tooltip title="Download Invoice">
//                         <IconButton
//                           color="primary"
//                           onClick={() => handleInvoiceDownload(project.invoice)}
//                         >
//                           <PictureAsPdf />
//                         </IconButton>
//                       </Tooltip>
//                     </TableCell>
//                     <TableCell align="center">
//                       <Tooltip
//                         title={
//                           project.feedbackGiven
//                             ? "Feedback Already Given"
//                             : "Give Feedback"
//                         }
//                       >
//                         <IconButton
//                           color={project.feedbackGiven ? "success" : "primary"}
//                           onClick={() => handleFeedback(project)}
//                           disabled={project.feedbackGiven}
//                         >
//                           <Feedback />
//                         </IconButton>
//                       </Tooltip>
//                     </TableCell>
//                     <TableCell align="center">
//                       <Tooltip title="View Notices">
//                         <IconButton
//                           color="secondary"
//                           onClick={() => handleNoticeView(project)}
//                         >
//                           <Notifications />
//                         </IconButton>
//                       </Tooltip>
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         </CardContent>
//       </Card>
//     </Container>
//   );
// };

// export default MyInvestment;
// import React, { useState, useEffect } from "react";
// import {
//   ThemeProvider,
//   createTheme,
//   Box,
//   Typography,
//   Container,
//   CssBaseline,
//   Button,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import * as XLSX from "xlsx";
// import axios from "axios";

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#000000",
//     },
//     secondary: {
//       main: "#dc004e",
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//   },
// });

// function Projects() {
//   const [rows, setRows] = useState([]);
//   const [filteredRows, setFilteredRows] = useState([]);
//   const [filters, setFilters] = useState({
//     title: "",
//     student_name: "",
//     status: "",
//     project_type: "",
//   });
//   const [filterOptions, setFilterOptions] = useState({
//     titles: [],
//     studentNames: [],
//     statuses: [],
//     projectTypes: [],
//   });
//   const [pageSize, setPageSize] = useState(10);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get("https://puneexpobackend.tdtlworld.com/api/all_ideas/", {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//         },
//       });

//       const data = response.data.data;

//       const formatted = data.map((item, index) => ({
//         id: item.id,
//         serial_number: index + 1,
//         ...item,
//       }));

//       setRows(formatted);
//       setFilteredRows(formatted);

//       setFilterOptions({
//         titles: [...new Set(formatted.map((i) => i.title))],
//         studentNames: [...new Set(formatted.map((i) => i.student_name))],
//         statuses: [...new Set(formatted.map((i) => i.status))],
//         projectTypes: [...new Set(formatted.map((i) => i.project_type))],
//       });
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setSnackbarMessage("Error fetching data. Please try again.");
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   useEffect(() => {
//     let filtered = rows;
//     Object.entries(filters).forEach(([key, value]) => {
//       if (value) {
//         filtered = filtered.filter((row) =>
//           row[key]?.toString().toLowerCase().includes(value.toLowerCase())
//         );
//       }
//     });
//     setFilteredRows(filtered);
//   }, [filters, rows]);

//   const handleDownloadExcel = () => {
//     const exportData = filteredRows.map((row) => [
//       row.serial_number,
//       row.title,
//       row.student_name,
//       row.student_email,
//       row.contact_number,
//       row.project_type,
//       row.status,
//       row.ai_score,
//     ]);

//     const worksheet = XLSX.utils.aoa_to_sheet([
//       [
//         "S.No.",
//         "Title",
//         "Student Name",
//         "Email",
//         "Contact",
//         "Project Type",
//         "Status",
//         "AI Score",
//       ],
//       ...exportData,
//     ]);

//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Ideas");
//     XLSX.writeFile(workbook, "All_Ideas_List.xlsx");
//   };

//   const columns = [
//     { field: "serial_number", headerName: "S.No.", width: 80 },
//     { field: "title", headerName: "Title", flex: 1, minWidth: 180 },
//     { field: "student_name", headerName: "Student Name", flex: 1, minWidth: 180 },
//     { field: "student_email", headerName: "Email", flex: 1, minWidth: 200 },
//     { field: "contact_number", headerName: "Contact", flex: 1, minWidth: 140 },
//     { field: "project_type", headerName: "Project Type", flex: 1, minWidth: 180 },
//     { field: "status", headerName: "Status", width: 120 },
//     { field: "ai_score", headerName: "AI Score", width: 100 },
//   ];

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Container maxWidth="lg" sx={{ mt: 10, mb: 4 }}>
//         <Typography variant="h4" sx={{ mb: 4, fontWeight: "bold", color: "#37474f" }}>
//           Ideas Submitted
//         </Typography>

//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             justifyContent: "space-between",
//             alignItems: "center",
//             mb: 2,
//           }}
//         >
//           <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
//             <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Title</InputLabel>
//               <Select name="title" value={filters.title} onChange={handleFilterChange} label="Title">
//                 <MenuItem value="">All</MenuItem>
//                 {filterOptions.titles.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Student</InputLabel>
//               <Select
//                 name="student_name"
//                 value={filters.student_name}
//                 onChange={handleFilterChange}
//                 label="Student"
//               >
//                 <MenuItem value="">All</MenuItem>
//                 {filterOptions.studentNames.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Status</InputLabel>
//               <Select name="status" value={filters.status} onChange={handleFilterChange} label="Status">
//                 <MenuItem value="">All</MenuItem>
//                 {filterOptions.statuses.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Project Type</InputLabel>
//               <Select
//                 name="project_type"
//                 value={filters.project_type}
//                 onChange={handleFilterChange}
//                 label="Project Type"
//               >
//                 <MenuItem value="">All</MenuItem>
//                 {filterOptions.projectTypes.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>

//           <Button variant="contained" color="primary" onClick={handleDownloadExcel}>
//             Download Excel
//           </Button>
//         </Box>

//         <Box sx={{ height: 600, width: "100%" }}>
//           {loading ? (
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 height: "100%",
//               }}
//             >
//               <CircularProgress />
//             </Box>
//           ) : (
//             <DataGrid
//               rows={filteredRows}
//               columns={columns}
//               pageSize={pageSize}
//               onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
//               rowsPerPageOptions={[5, 10, 20]}
//               pagination
//             />
//           )}
//         </Box>
//       </Container>

//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </ThemeProvider>
//   );
// }

// export default Projects;

// import React, { useState, useEffect } from "react";
// import {
//   ThemeProvider,
//   createTheme,
//   Box,
//   Typography,
//   Container,
//   CssBaseline,
//   Button,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import * as XLSX from "xlsx";
// import axios from "axios";
// import { IconButton } from "@mui/material";
// import VisibilityIcon from "@mui/icons-material/Visibility";

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#000000",
//     },
//     secondary: {
//       main: "#dc004e",
//     },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//   },
// });

// const BASE_URL = "https://puneexpobackend.tdtlworld.com";

// function Projects() {
//   const [rows, setRows] = useState([]);
//   const [filteredRows, setFilteredRows] = useState([]);
//   const [filters, setFilters] = useState({
//     title: "",
//     student_name: "",
//     status: "",
//     project_type: "",
//   });
//   const [filterOptions, setFilterOptions] = useState({
//     titles: [],
//     studentNames: [],
//     statuses: [],
//     projectTypes: [],
//   });
//   const [pageSize, setPageSize] = useState(10);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       const response = await axios.get(`${BASE_URL}/api/all_ideas/`, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
//         },
//       });

//       const data = response.data.data;

//       const formatted = data.map((item, index) => ({
//         id: item.id,
//         serial_number: index + 1,
//         ...item,
//       }));

//       setRows(formatted);
//       setFilteredRows(formatted);

//       setFilterOptions({
//         titles: [...new Set(formatted.map((i) => i.title))],
//         studentNames: [...new Set(formatted.map((i) => i.student_name))],
//         statuses: [...new Set(formatted.map((i) => i.status))],
//         projectTypes: [...new Set(formatted.map((i) => i.project_type))],
//       });
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setSnackbarMessage("Error fetching data. Please try again.");
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters((prev) => ({ ...prev, [name]: value }));
//   };

//   useEffect(() => {
//     let filtered = rows;
//     Object.entries(filters).forEach(([key, value]) => {
//       if (value) {
//         filtered = filtered.filter((row) =>
//           row[key]?.toString().toLowerCase().includes(value.toLowerCase())
//         );
//       }
//     });
//     setFilteredRows(filtered);
//   }, [filters, rows]);

//   const handleDownloadExcel = () => {
//     const exportData = filteredRows.map((row) => [
//       row.serial_number,
//       row.title,
//       row.student_name,
//       row.student_email,
//       row.contact_number,
//       row.project_type,
//       row.status,
      
//     ]);

//     const worksheet = XLSX.utils.aoa_to_sheet([
//       [
//         "S.No.",
//         "Title",
//         "Student Name",
//         "Email",
//         "Contact",
//         "Project Type",
//         "Status",
        
//       ],
//       ...exportData,
//     ]);

//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Ideas");
//     XLSX.writeFile(workbook, "All_Ideas_List.xlsx");
//   };

//   const columns = [
//     { field: "serial_number", headerName: "S.No.", width: 80 },
//     { field: "title", headerName: "Title", flex: 1, minWidth: 180 },
//     // { field: "student_name", headerName: "Student Name", flex: 1, minWidth: 180 },
//     // { field: "student_email", headerName: "Email", flex: 1, minWidth: 200 },
//     // { field: "contact_number", headerName: "Contact", flex: 1, minWidth: 140 },4
//     { field: "project_type", headerName: "Project Type", flex: 1, minWidth: 180 },
//     {
//         field: "idea",
//         headerName: "PDF",
//         width: 100,
//         renderCell: (params) =>
//           params.value ? (
//             <IconButton
//             component="a"
//             href={`${BASE_URL}${params.value}`}
//             target="_blank"
//             rel="noopener noreferrer"
//             size="small"
//             color="primary"
//           >
//             <VisibilityIcon />
//           </IconButton>
//           ) : (
//             "Not Submitted"
//           ),
//       },
//       {
//         field: "ppt",
//         headerName: "PPT",
//         width: 100,
//         renderCell: (params) =>
//           params.value ? (
//             <IconButton
//               component="a"
//               href={`${BASE_URL}${params.value}`}
//               target="_blank"
//               rel="noopener noreferrer"
//               size="small"
//               color="primary"
//             >
//               <VisibilityIcon />
//             </IconButton>
//           ) : (
//             "Not Submitted"
//           ),
//       },
//       {
//         field: "video_file",
//         headerName: "Video",
//         width: 100,
//         renderCell: (params) =>
//           params.value ? (
//             <IconButton
//               component="a"
//               href={`${BASE_URL}${params.value}`}
//               target="_blank"
//               rel="noopener noreferrer"
//               size="small"
//               color="primary"
//             >
//               <VisibilityIcon />
//             </IconButton>
//           ) : (
//             "Not Submitted"
//           ),
//       },
//     { field: "status", headerName: "Status", width: 120 },
    
  
//   ];

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <Container maxWidth="lg" sx={{ mt: 10, mb: 4 }}>
//         <Typography variant="h4" sx={{ mb: 4, fontWeight: "bold", color: "#37474f" }}>
//           Ideas Submitted
//         </Typography>

//         <Box
//           sx={{
//             display: "flex",
//             flexWrap: "wrap",
//             justifyContent: "space-between",
//             alignItems: "center",
//             mb: 2,
//           }}
//         >
//           <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
//             <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Title</InputLabel>
//               <Select name="title" value={filters.title} onChange={handleFilterChange} label="Title">
//                 <MenuItem value="">All</MenuItem>
//                 {filterOptions.titles.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Student</InputLabel>
//               <Select
//                 name="student_name"
//                 value={filters.student_name}
//                 onChange={handleFilterChange}
//                 label="Student"
//               >
//                 <MenuItem value="">All</MenuItem>
//                 {filterOptions.studentNames.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Status</InputLabel>
//               <Select name="status" value={filters.status} onChange={handleFilterChange} label="Status">
//                 <MenuItem value="">All</MenuItem>
//                 {filterOptions.statuses.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
//               <InputLabel>Project Type</InputLabel>
//               <Select
//                 name="project_type"
//                 value={filters.project_type}
//                 onChange={handleFilterChange}
//                 label="Project Type"
//               >
//                 <MenuItem value="">All</MenuItem>
//                 {filterOptions.projectTypes.map((option) => (
//                   <MenuItem key={option} value={option}>
//                     {option}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>

//           <Button variant="contained" color="primary" onClick={handleDownloadExcel}>
//             Download Excel
//           </Button>
//         </Box>

//         <Box sx={{ height: 600, width: "100%" }}>
//           {loading ? (
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 height: "100%",
//               }}
//             >
//               <CircularProgress />
//             </Box>
//           ) : (
//             <DataGrid
//               rows={filteredRows}
//               columns={columns}
//               pageSize={pageSize}
//               onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
//               rowsPerPageOptions={[5, 10, 20]}
//               pagination
//             />
//           )}
//         </Box>
//       </Container>

//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={() => setSnackbarOpen(false)}
//         anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//       >
//         <Alert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//           sx={{ width: "100%" }}
//         >
//           {snackbarMessage}
//         </Alert>
//       </Snackbar>
//     </ThemeProvider>
//   );
// }

// export default Projects;
import React, { useState, useEffect } from "react";
import {
  ThemeProvider,
  createTheme,
  Box,
  Typography,
  Container,
  CssBaseline,
  Button,
  Snackbar,
  Alert,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Modal,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import axios from "axios";
import { IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import QrCodeIcon from "@mui/icons-material/QrCode";

const theme = createTheme({
  palette: {
    primary: {
      main: "#000000",
    },
    secondary: {
      main: "#dc004e",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const BASE_URL = "https://puneexpobackend.tdtlworld.com";

function Projects() {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [filters, setFilters] = useState({
    title: "",
    student_name: "",
    status: "",
    project_type: "",
  });
  const [filterOptions, setFilterOptions] = useState({
    titles: [],
    studentNames: [],
    statuses: [],
    projectTypes: [],
  });
  const [pageSize, setPageSize] = useState(10);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [loading, setLoading] = useState(true);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [qrImage, setQrImage] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/all_ideas/`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      const data = response.data.data;

      const formatted = data.map((item, index) => ({
        id: item.id,
        serial_number: index + 1,
        ...item,
      }));

      setRows(formatted);
      setFilteredRows(formatted);

      setFilterOptions({
        titles: [...new Set(formatted.map((i) => i.title))],
        studentNames: [...new Set(formatted.map((i) => i.student_name))],
        statuses: [...new Set(formatted.map((i) => i.status))],
        projectTypes: [...new Set(formatted.map((i) => i.project_type))],
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      setSnackbarMessage("Error fetching data. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    let filtered = rows;
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        filtered = filtered.filter((row) =>
          row[key]?.toString().toLowerCase().includes(value.toLowerCase())
        );
      }
    });
    setFilteredRows(filtered);
  }, [filters, rows]);

  const handleDownloadExcel = () => {
    const exportData = filteredRows.map((row) => [
      row.serial_number,
      row.title,
      row.student_name,
      row.student_email,
      row.contact_number,
      row.project_type,
      row.status,
      row.ai_score,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      [
        "S.No.",
        "Title",
        "Student Name",
        "Email",
        "Contact",
        "Project Type",
        "Status",
        "AI Score",
      ],
      ...exportData,
    ]);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Ideas");
    XLSX.writeFile(workbook, "All_Ideas_List.xlsx");
  };

  const handleQrClick = (qrPath) => {
    setQrImage(`${BASE_URL}${qrPath}`);
    setQrModalOpen(true);
  };

  const handleCloseQrModal = () => {
    setQrModalOpen(false);
    setQrImage("");
  };

  const columns = [
    { field: "serial_number", headerName: "S.No.", width: 80 },
    { field: "title", headerName: "Title", flex: 1, minWidth: 180 },
    { field: "project_type", headerName: "Project Type", flex: 1, minWidth: 180 },
    {
      field: "idea",
      headerName: "PDF",
      width: 100,
      renderCell: (params) =>
        params.value ? (
          <IconButton
            component="a"
            href={`${BASE_URL}${params.value}`}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            color="primary"
          >
            <VisibilityIcon />
          </IconButton>
        ) : (
          "Not Submitted"
        ),
    },
    {
      field: "ppt",
      headerName: "PPT",
      width: 100,
      renderCell: (params) =>
        params.value ? (
          <IconButton
            component="a"
            href={`${BASE_URL}${params.value}`}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            color="primary"
          >
            <VisibilityIcon />
          </IconButton>
        ) : (
          "Not Submitted"
        ),
    },
    {
      field: "video_file",
      headerName: "Video",
      width: 100,
      renderCell: (params) =>
        params.value ? (
          <IconButton
            component="a"
            href={`${BASE_URL}${params.value}`}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            color="primary"
          >
            <VisibilityIcon />
          </IconButton>
        ) : (
          "Not Submitted"
        ),
    },
    // { field: "status", headerName: "Status", width: 120 },
    {
      field: "ai_score",
      headerName: "AI Score",
      width: 100,
    },
    {
      field: "qr_code",
      headerName: "Scan And Give Feedback",
      width: 100,
      renderCell: (params) =>
        params.value ? (
          <IconButton size="small" color="secondary" onClick={() => handleQrClick(params.value)}>
            <QrCodeIcon />
          </IconButton>
        ) : (
          "Not Available"
        ),
    },
  ];

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="lg" sx={{ mt: 10, mb: 4 }}>
        <Typography variant="h4" sx={{ mb: 4, fontWeight: "bold", color: "#37474f" }}>
          Ideas Submitted
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Title</InputLabel>
              <Select name="title" value={filters.title} onChange={handleFilterChange} label="Title">
                <MenuItem value="">All</MenuItem>
                {filterOptions.titles.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Student</InputLabel>
              <Select
                name="student_name"
                value={filters.student_name}
                onChange={handleFilterChange}
                label="Student"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.studentNames.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Status</InputLabel>
              <Select name="status" value={filters.status} onChange={handleFilterChange} label="Status">
                <MenuItem value="">All</MenuItem>
                {filterOptions.statuses.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
              <InputLabel>Project Type</InputLabel>
              <Select
                name="project_type"
                value={filters.project_type}
                onChange={handleFilterChange}
                label="Project Type"
              >
                <MenuItem value="">All</MenuItem>
                {filterOptions.projectTypes.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>

          <Button variant="contained" color="primary" onClick={handleDownloadExcel}>
            Download Excel
          </Button>
        </Box>

        <Box sx={{ height: 600, width: "100%" }}>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[5, 10, 20]}
              pagination
            />
          )}
        </Box>
      </Container>

      <Modal open={qrModalOpen} onClose={handleCloseQrModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <Typography variant="h6" sx={{ mb: 2 }}>
            QR Code
          </Typography>
          <img src={qrImage} alt="QR Code" style={{ width: 200, height: 200 }} />
        </Box>
      </Modal>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </ThemeProvider>
  );
}

export default Projects;
